'use client';

import { useEffect } from 'react';
import Stage from './lib/services/stage/stage';

export default function Gravy()
 {
  useEffect(() => {
    const stage = Stage.instance();
    console.log('Stage initialized', stage);
  }, []);

  return null;
}